module.exports = __webpack_public_path__ + "img/tracking.f23a20cc.png";